import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  ViewEncapsulation,
  EventEmitter,
  Output
} from "@angular/core";
import { from } from "rxjs";

@Component({
  selector: "tab-div",
  templateUrl: "./tab-div.component.html",
  styleUrls: ["./tab-div.component.scss"],
  encapsulation:ViewEncapsulation.Emulated
})
export class TabDivComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() DATA;
  @Input() CONFIG;
  @Output() tabClicked = new EventEmitter();
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}
  getAllvalue() {}

  tabClick(tab) {
    this.tabClicked.emit(tab);
  }

}
